import { InviteCreatorEmptyMockResults } from './InviteCreatorEmptyMockResults';
import { InviteCreatorEmptyResults } from './InviteCreatorEmptyResults';

export const InviteCreatorEmptyPage: React.FC = () => {
  // TODO: Remove this flag once the feature is checked and everything is refactored
  const foamEmptyTalentPageFlag = true;

  return (
    <>
      {foamEmptyTalentPageFlag ? (
        <InviteCreatorEmptyMockResults />
      ) : (
        <InviteCreatorEmptyResults />
      )}
    </>
  );
};
